import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoaderService } from '../../Services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    @if (loaderService.isLoading(id)) {
    <div
      class="absolute inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-[2px]"
    >
      <p-progressSpinner
        inputStyleClass="w-16 h-16"
        strokeWidth="4"
        fill="transparent"
        animationDuration=".5s"
      />
    </div>
    }
  `,
})
export class LoaderComponent {
  public loaderService = inject(LoaderService);
  @Input() id: string = 'global';
}
